import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb"

import { get } from "helpers/api_helper"
import CustomerForm from "components/Customers/CustomerForm"
import SpinnerLoader from "components/Loader/SpinnerLoader"
const EditCustomer = props => {
  const [customer, setCustomer] = useState({})
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    get(`customers/${props.match.params.id}`).then(res => {
      const { status, result } = res
      setCustomer(result)
      setLoading(false)
    })
  }, [])

  return (
    <div className="page-content">
      <MetaTags>
        <title>Customers | GoFetchIt</title>
      </MetaTags>
      <div className="container-fluid">
        <Breadcrumb
          breadcrumb1={{ title: "Customers", href: "/customers" }}
          breadcrumbItem="Edit Customer"
        />
        {loading ? (
          <SpinnerLoader/>
        ) : (
          <CustomerForm data={customer} customer_id={props.match.params.id} />
        )}
      </div>
    </div>
  )
}

export default EditCustomer
